export const TYPES = {
  SET_FINANCE_SUPPORTER_ALL: "finance_supporter/SET_FINANCE_SUPPORTER_ALL",
  SET_FINANCE_SUPPORTER_OPEN_ADD:
    "finance_supporter/SET_FINANCE_SUPPORTER_OPEN_ADD",
  SET_FINANCE_SUPPORTER_OPEN_EDIT:
    "finance_supporter/SET_FINANCE_SUPPORTER_OPEN_EDIT",
  SET_FINANCE_SUPPORTER_SELECTED:
    "finance_supporter/SET_FINANCE_SUPPORTER_SELECTED",
  SET_FINANCE_SUPPORTER_SEARCH:
    "finance_supporter/SET_FINANCE_SUPPORTER_SEARCH",
  SET_FINANCE_SUPPORTER_DATES: "finance_supporter/SET_FINANCE_SUPPORTER_DATES",
};
